import { Stack } from "@mui/material";
import { type FC } from "react";
import { isMobile } from "react-device-detect";
import TeamsSelectTable, { type TeamsSelectTableProps } from "./TeamsSelectTable";

type TeamsSelectProps = TeamsSelectTableProps

const TeamsSelect: FC<TeamsSelectProps> = (props) => {
  return (
    <Stack height="50vh" maxWidth={isMobile ? "90vw" : "40vw"} minHeight={0} overflow="hidden">
      <TeamsSelectTable {...props} />
    </Stack>
  );
};

export default TeamsSelect;
